import { Button, Col, Row, Space } from "antd"
import { useEffect } from "react"
import { useState } from "react"
import { useParams } from "react-router-dom"
import { baseAxiosNoInfo } from "../../../tool/axios"

interface data {
    room_number:string,
    check_in_day_range:string,
    room_type_name:string
}
interface checkInRecordData {
    room_number: string,
    check_in_day_range: string,
    room_type_name: string
}
interface Prop{
    data:checkInRecordData[]
    onFetched?: (d:data[])=>void
}
export default function(prop:Prop){


    return <div className="modules">
        <div className="top clear">
            <h3 className="fl"><span className="fl">入住信息</span> </h3>
        </div>
        <div className="content">
            {prop.data.map((el:data)=><Row style={{width:'100%',marginTop:18}}>
                <Col span={8}>
                    <Space>
                        <p>房间号：</p>
                        <p className="right-text">{el.room_number}</p>
                    </Space>
                </Col>
                <Col span={8}>
                    <Space>
                        <p>入住时间段：</p>
                        <p className="right-text">{el.check_in_day_range}</p>
                    </Space>
                </Col>
                <Col span={8}>
                    <Space>
                        <p>房型：</p>
                        <p className="right-text">{el.room_type_name}</p>
                    </Space>
                </Col>
            </Row>)}
        </div>
    </div>
}